import useTranslate from 'common/hooks/use-translate'
import useHppContext from 'common/hooks/use-hpp-context'

function useEligibilityPaymentMethodCategoryAwareTranslate() {
  const {
    eligibility: { paymentMethodCategories }
  } = useHppContext()
  const translate = useTranslate()

  const paymentMethodCategory =
    paymentMethodCategories && paymentMethodCategories.length === 1
      ? paymentMethodCategories[0].toLowerCase()
      : null

  return function eligibilityPaymentMethodCategoryAwareTranslate(key, options?) {
    const fallbackTranslation = translate(`${key}.fallback`, options)

    if (paymentMethodCategory) {
      return translate(`${key}.${paymentMethodCategory}`, options) || fallbackTranslation
    }

    return fallbackTranslation
  }
}

export default useEligibilityPaymentMethodCategoryAwareTranslate
